module.exports = __webpack_public_path__ + "static/korea-a28c1772f3ca6e6564ec4d6604ae3746.png";